import { appConfigFor } from 'constants/appConfigFor';
import { APP_ENVIRONMENT } from 'constants/constants';
import { Environment } from 'models/Environment';
import { setNewRelicAppId } from 'helpers/newRelic';

setNewRelicAppId(appConfigFor(APP_ENVIRONMENT as Environment).newRelicAppId);

import('bootstrap');
export {};

//export const dummy = "This line is only needed if you see, isolatedModules issue"
